<template>
  <div class="conversations-panel">
    <h1 class="page-title">Webhooks</h1>

    <div class="page-content">
      <section class="conversations-side">
        <aside class="conversations-list -webhooks">
          <div v-if="loadMoreState === 'loading' && conversations.length === 0" class="conversation-label -empty">
            Fetching webhooks
          </div>

          <div v-if="loadMoreState === 'ready' && conversations.length === 0" class="conversation-label -empty">
            No webhooks found
          </div>

          <webhook-label
            v-for="conversation in conversations"
            :key="conversation.id"
            :active="currentConversation && conversation.id === currentConversation.id"
            :conversation="conversation"
            @select="setWebhook"
          />

          <action-button
            v-if="hasMoreConversations"
            class="button -full-width -not-rounded"
            :text="'Load More'"
            :state="loadMoreState"
            @pressed="loadMore"
          />
        </aside>
      </section>

      <section v-if="currentConversation" class="current-conversation -webhooks">
        <span v-if="loadingMessages" class="loading">Loading&hellip;</span>
        <message-list v-else :messages="messagesForConversation(currentConversation.id)" />

        <div class="take-control">
          <template v-if="currentConversation.webhook_status === 'pending_approval'">
            <span class="button" @click="approve">Approve</span>
            <span class="button -danger" @click="deny">Deny</span>
          </template>

          <template v-else>
            <span class="status">{{ currentConversation.webhook_status | unslugify }}</span>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import actionButton from "@/components/actionButton.vue";
import messageList from "@/components/messageList.vue";
import webhookLabel from "@/components/webhookLabel.vue";
import auth from "@/helpers/auth";

export default {
  components: { webhookLabel, messageList, actionButton },

  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      loadingMessages: false,
      loadMoreState: "normal",
      updatingStatus: false
    };
  },

  computed: {
    ...mapState({
      conversations: (state) => state.conversationWebhooks.all,
      currentConversation: (state) => state.conversationWebhooks.current,
      hasMoreConversations: (state) => state.conversationWebhooks.hasMore
    }),
    ...mapGetters(["messagesForConversation"])
  },

  watch: {
    conversations() {
      this.loadMoreState = "normal";
    },

    currentConversation() {
      this.loadingMessages = true;

      this.$store
        .dispatch("fetchMessages", this.currentConversation.id)
        .then(() => {
          this.loadingMessages = false;
        })
        .catch((err) => {
          console.error("Error fetching messages", err);
          this.loadingMessages = false;
        });
    }
  },

  created() {
    this.loadMore();
  },

  destroyed() {
    this.$store.commit("clearWebhooks");
  },

  methods: {
    setWebhook(conversation) {
      this.$store.dispatch("changeCurrentWebhook", conversation);
    },

    loadMore() {
      this.loadMoreState = "loading";
      this.$store.dispatch("fetchWebhooks");
    },

    approve() {
      if (this.updatingStatus) return;
      this.updatingStatus = true;

      this.$store.dispatch("setWebhookStatus", "approved").then(() => {
        this.updatingStatus = false;
      });
    },

    deny() {
      if (this.updatingStatus) return;
      this.updatingStatus = true;

      this.$store.dispatch("setWebhookStatus", "denied").then(() => {
        this.updatingStatus = false;
      });
    }
  }
};
</script>
